import classnames from 'classnames';
import React from 'react';

import '@eika/rich-icon-style';

import RichIconTypes from './RichIconTypes';

export interface IconProps {
    type: RichIconTypes;
    className?: string;
    ariaLabel?: string;
    /**
     * override the minheight set in the css
     * @default 200
     */
    minHeight?: number;
    /**
     * set maxheight for the icon
     * @default none
     */
    maxHeight?: number;
}

const RichIcon = ({ type, className, ariaLabel, minHeight = 200, maxHeight }: IconProps): JSX.Element => {
    const optionalAriaLabel = ariaLabel ? { 'aria-label': ariaLabel } : {};
    return (
        <figure
            aria-hidden={!ariaLabel}
            style={
                {
                    '--rich-icon-min-height': `${minHeight}px`,
                    '--rich-icon-max-height': maxHeight ? `${maxHeight}px` : 'none',
                } as React.CSSProperties
            }
            className={classnames('sgw-rich-icon', `icon--${type}`, className)}
            {...optionalAriaLabel}
        />
    );
};

export default RichIcon;
